<template>
  <div>
    <b-modal
      style="padding:15px"
      size="lg"
      id="AddProductionModal"
      ref="modal"
      title="Add Production"
      ok-title="Submit"
      cancel-title="Add Multiple"
      @hidden="resetModal()"
      @ok="handleOk"
      @cancel="addPerHourProduction"
      :ok-disabled="
        this.$refs.AddProductionForm != undefined
          ? !this.$refs.AddProductionForm.checkValidity()
          : true
      "
    >
      <form ref="AddProductionForm" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <b-form-group
              label="Production Date"
              label-for="datepicker-1"
              autocomplete="off"
            >
              <b-form-datepicker
                id="datepicker-1"
                v-model="ProDate"
                placeholder="Choose a date"
                local="en"
                required
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Time" label-for="Time" autocomplete="off">
              <b-form-select
                v-model="SelectedTimeSlot"
                :options="timeSlots"
                value-field="id"
                text-field="timeSlot"
                required
              >
                <b-form-select-option :value="null" disabled hidden
                  >Select Time</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
              <table
                class="table table-striped table-borderless cutom-table table-grey table-striped table-sm"
                style="font-size: 85%;"
              >
                <thead>
                  <tr>
                    <th role="columnheader" style="width:35%">Flour Type</th>
                    <th role="columnheader" style="width:35%">Flour Weight</th>
                    <th role="columnheader" style="width:20%">No Of Sacks</th>
                    <th role="columnheader" style="width:10%">#</th>
                  </tr>
                </thead>
                <tbody>
                  <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                  <tr v-if="perHourProduction.length <= 0">
                    <td class="center-td" colspan="4">No Items Added</td>
                  </tr>

                  <tr
                    v-else
                    v-for="(ph_production, k) in perHourProduction"
                    :key="k"
                  >
                    <td role="cell">
                      <b-form-group
                        label=""
                        label-for="Flour Type"
                        autocomplete="off"
                      >
                        <b-form-select
                          v-model="ph_production.flourTypeId"
                          :options="flourTypes"
                          value-field="id"
                          text-field="name"
                          @change="getFlourWeights(ph_production.flourTypeId)"
                          required
                          size="md"
                        >
                          <b-form-select-option :value="null" disabled hidden
                            >Select Type</b-form-select-option
                          >
                        </b-form-select>
                      </b-form-group>
                    </td>
                    <td role="cell">
                      <b-form-group
                        label=""
                        label-for="Flour Weight"
                        autocomplete="off"
                      >
                        <b-form-select
                          v-model="ph_production.flourWeightId"
                          :options="flourWeights"
                          value-field="flourWeight.id"
                          text-field="flourWeight.weight"
                          required
                          size="md"
                        >
                          <b-form-select-option :value="null" disabled hidden
                            >Select Weight</b-form-select-option
                          >
                        </b-form-select>
                      </b-form-group>
                    </td>
                    <td role="cell">
                      <b-form-group
                        label=""
                        label-for="No Of Sacks"
                        autocomplete="off"
                      >
                        <b-form-input
                          id="NoofSacks"
                          v-model="ph_production.NoOfSacksProduced"
                          type="number"
                          required
                          size="md"
                        ></b-form-input>
                      </b-form-group>
                    </td>
                    <td>
                      <b-button variant="transparent">
                        <b-icon
                          icon="trash"
                          variant="danger"
                          font-scale="1.1"
                          @click="deleteRow(k, ph_production)"
                        ></b-icon
                      ></b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>

        <!-- <div
          class="row"
          v-for="(ph_production, k) in perHourProduction"
          :key="k"
        >
          <div class="col-md-4">
            <b-form-group
              :label="k === 0 ? 'Flour Type' : ''"
              label-for="Flour Type"
              autocomplete="off"
            >
              <b-form-select
                v-model="ph_production.flourTypeId"
                :options="flourTypes"
                value-field="id"
                text-field="name"
                @change="getFlourWeights(ph_production.flourTypeId)"
                required
              >
                <b-form-select-option :value="null" disabled hidden
                  >Select Type</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              :label="k === 0 ? 'Flour Weight' : ''"
              label-for="Flour Weight"
              autocomplete="off"
            >
              <b-form-select
                v-model="ph_production.flourWeightId"
                :options="flourWeights"
                value-field="flourWeight.id"
                text-field="flourWeight.weight"
                required
              >
                <b-form-select-option :value="null" disabled hidden
                  >Select Weight</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              :label="k === 0 ? 'No Of Sacks' : ''"
              label-for="No Of Sacks"
              autocomplete="off"
            >
              <b-form-input
                id="NoofSacks"
                v-model="ph_production.NoOfSacksProduced"
                type="number"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-1">
            <b-form-group label="" label-for="No Of Sacks" autocomplete="off">
              <b-button variant="transparent">
                <b-icon
                  icon="dash-circle"
                  variant="danger"
                  @click="deleteRow(k, ph_production)"
                ></b-icon
              ></b-button>
            </b-form-group>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-12">
            <b-form-textarea
              id="textarea"
              v-model="Comments"
              placeholder="Comments"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </div>
        </div>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>

          <b-button
            variant="primary"
            size="md"
            class="float-right mr-2"
            @click="handleSubmit"
          >
            Submit
          </b-button>
          <b-button
            variant="info"
            size="md"
            class="float-right"
            @click="addPerHourProduction"
          >
            Add Multiple
          </b-button>
          <b-button
            variant="secondary"
            size="md"
            class="float-right"
            @click="$bvModal.hide('AddProductionModal')"
          >
            Close
          </b-button>
        </div>
      </template>
    </b-modal>
    <Toaster ref="toaster" />
  </div>
</template>

<script>
import axios from "axios";
// import config from '../config.js';
import Toaster from "../../toaster";
export default {
  name: "AddProduction",
  data() {
    return {
      moduleName: "Add Production",
      Weight: 0,
      Comments: null,
      CompanyId: null,
      flourWeights: null,
      flourTypes: null,
      timeSlots: null,
      SelectedTimeSlot: null,
      SelectedFlourType: null,
      SelectedFlourWeight: null,
      NoOfSacks: 0,
      ProDate: new Date(),
      perHourProduction: [
        { flourTypeId: null, flourWeightId: null, NoOfSacksProduced: 0 },
      ],
    };
  },
  components: {
    Toaster,
  },
  created() {
    this.gettimeSlots();
    // this.getFlourWeights();
    this.getFlourTypes();
  },

  methods: {
    getFlourWeights(flourTypeId) {
      axios
        .post("/flourweighttypelink/getAll", {
          CompanyId: this.$auth.user().companyId,
          FlourTypeId: flourTypeId,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            this.flourWeights = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
            this.flourWeights = null;
          } else {
            this.flourWeights = null;
            this.SelectedFlourWeight = null;
          }
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },

    gettimeSlots() {
      axios
        .post("/timeslots/getall", { CompanyId: this.$auth.user().companyId })
        .then((res) => {
          //  console.log(res.data)
          if (res.data.status == 1) {
            this.timeSlots = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          }
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },

    getFlourTypes() {
      axios
        .post("/flourtype/getall", { CompanyId: this.$auth.user().companyId })
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            this.flourTypes = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          }
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },

    addProduction() {
      if (
        this.SelectedTimeSlot == null ||
        this.perHourProduction[0].flourTypeId == null ||
        this.perHourProduction[0].flourWeightId == null ||
        this.perHourProduction[0].NoOfSacksProduced === 0
      ) {
        this.$refs.toaster.showToast(
          "Error",
          "danger",
          "Please fill all the fields"
        );
        return;
      }
      let model = {
        // NoOfSacksProduced: Number(this.NoOfSacks),
        ProductionDate: this.ProDate,
        Description: this.Comments,
        TimeId: this.SelectedTimeSlot,
        UserId: this.$auth.user().id,
        // FlourWeightId: this.SelectedFlourWeight,
        // FlourTypeId: this.SelectedFlourType,
        IsAdjustmentEntry: false,
        CompanyId: this.$auth.user().companyId,
        perHourProductions: this.perHourProduction,
      };
      // console.log(model)
      axios
        .post("/production/Add", model)
        .then((res) => {
          if (res.data.status == 1) {
            this.$refs.toaster.showToast(
              "Success",
              "success",
              "Production has been added successfully"
            );
            this.$bvModal.hide("AddProductionModal");
            this.$parent.getPage();
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          }
        })
        .catch((err) => {
          console.warn("error during http call", err);
        });
    },

    addPerHourProduction() {
      this.perHourProduction.push({
        flourTypeId: null,
        flourWeightId: null,
        NoOfSacksProduced: 0,
      });
    },

    deleteRow(index, pp_production) {
      var idx = this.perHourProduction.indexOf(pp_production);
      console.log(idx, index);
      if (idx > -1 && this.perHourProduction.length > 1) {
        this.perHourProduction.splice(idx, 1);
      }
    },

    checkFormValidity() {
      const valid = this.$refs.AddProductionForm.checkValidity();
      // this.usernameState = valid
      return valid;
    },

    resetModal() {
      this.NoOfSacks = 0;
      this.ProductionDate = new Date();
      this.SelectedTimeSlot = null;
      this.SelectedFlourType = null;
      this.SelectedFlourWeight = null;
      this.Comments = null;
      this.perHourProduction[0].flourTypeId = null;
      this.perHourProduction[0].flourWeightId = null;
      this.perHourProduction[0].NoOfSacksProduced = 0;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      this.addProduction();
    },
  },
};
</script>

<style scoped>
button {
  margin: 0.25rem;
}
button.btn.btn-transparent {
  /* margin-top: 50%; */
  outline: none;
  border: none;
}
button.btn.btn-transparent:focus {
  box-shadow: none;
}
.form-group {
    margin-bottom: 0.1rem;
}

</style>
